/* eslint-disable */
import type { TransactionReturnType } from "../types"
import type { Abi, Address } from "viem"
import type { Config } from "wagmi"

import { voterAbi } from "@/domains/abis"

import { simulatedTransaction } from "../simulated-transaction"

type CreateGaugeProps = {
  account: Address
  chainId: number
  config: Config
  pairAddress: Address
  voterAddress: Address
}

export const createGauge = async ({
  account,
  chainId,
  config,
  pairAddress,
  voterAddress,
}: CreateGaugeProps): Promise<TransactionReturnType> => {
  try {
    const result = await simulatedTransaction({
      config,
      simulateArgs: {
        abi: voterAbi as Abi,
        account,
        address: voterAddress,
        args: [pairAddress],
        chainId,
        functionName: "createGauge",
      },
      gas: BigInt(9600000),
    })
    return result
  } catch (error: any) {
    console.error("createGauge", error)
    return { success: false, error: error.message, code: error.code }
  }
}
